import React from 'react';

const OrderItem = ({ order, onUpdateStatus }) => {
  const statusColors = {
    pendiente: 'bg-yellow-100 text-yellow-800',
    en_proceso: 'bg-blue-100 text-blue-800',
    completado: 'bg-green-100 text-green-800'
  };

  return (
    <div className="bg-white rounded-lg shadow-sm p-4 mb-4">
      <div className="flex justify-between items-start mb-2">
        <div>
          <h4 className="font-medium text-gray-800">Pedido #{order.id}</h4>
          <p className="text-sm text-gray-500">{new Date(order.date).toLocaleString()}</p>
        </div>
        <span className={`text-xs px-2 py-1 rounded-full ${statusColors[order.status]}`}>
          {order.status.replace('_', ' ')}
        </span>
      </div>
      
      <div className="border-t border-gray-100 pt-3 mb-3">
        <p className="text-sm font-medium text-gray-800 mb-1">Productos:</p>
        <ul className="text-sm text-gray-600">
          {order.items.map((item, index) => (
            <li key={index} className="flex justify-between">
              <span>- {item.name}</span>
              <span>${item.price}</span>
            </li>
          ))}
        </ul>
      </div>

      <div className="border-t border-gray-100 pt-3 mb-3">
        <p className="text-sm font-medium text-gray-800 mb-1">Total: ${order.total.toFixed(2)}</p>
      </div>

      <div className="flex space-x-2 justify-end">
        <select
          value={order.status}
          onChange={(e) => onUpdateStatus(order.id, e.target.value)}
          className="text-sm border border-gray-300 rounded-lg px-3 py-1 focus:ring-2 focus:ring-green-500"
        >
          <option value="pendiente">Pendiente</option>
          <option value="en_proceso">En proceso</option>
          <option value="completado">Completado</option>
        </select>
      </div>
    </div>
  );
};

export default OrderItem;